<script lang="ts">
  import { Badge, Col, Label } from "sveltestrap";
  import data from "../../../../Data/Forms/FormsControls/Megaoption.json";
</script>

{#each data.horigentalsdata as formItem}
  <Col sm="9" class={formItem.class}>
    <div class="card">
      <div class="media p-20">
        <div class="form-check radio radio-{formItem.color} me-3">
          <input
            class="form-check-input"
            id={formItem.id}
            type="radio"
            name="radio1"
            value="option1"
          />
          <Label class="form-check-label" for={formItem.id} />
        </div>
        <div class="media-body">
          <h6 class="mt-0 mega-title-badge">
            {formItem.name}
            <Badge color={formItem.color} class="pull-right digits"
              >{formItem.badge}</Badge
            >
          </h6>
          <p>{formItem.detail}</p>
        </div>
      </div>
    </div>
  </Col>
{/each}
